import { useState, useEffect } from 'react'
import useAuthStore from '@/store/useAuthStore'

interface IUseTimerProps {
  initialTime: number
}

const useTimer = ({ initialTime }: IUseTimerProps) => {
  const { timerStartTimestamp, setTimerStartTimestamp } = useAuthStore()
  const [currentTime, setCurrentTime] = useState(Date.now())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(Date.now())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const start = () => {
    setTimerStartTimestamp(Date.now())
  }

  const reset = () => {
    setTimerStartTimestamp(Date.now())
  }

  const remainingTime = timerStartTimestamp
    ? Math.max(
        0,
        Math.floor(
          (timerStartTimestamp + initialTime * 1000 - currentTime) / 1000
        )
      )
    : 0

  const formattedTime = `${Math.floor(remainingTime / 60)
    .toString()
    .padStart(2, '0')}:${(remainingTime % 60).toString().padStart(2, '0')}`

  return { remainingTime, formattedTime, start, reset }
}

export default useTimer
